import React, { useEffect, useState } from "react";
import "./index.css";
import { useNavigate } from "react-router-dom";
import superAdminApis from "../../api/services/admin-pages/superAdmin";
import { toast } from "react-toastify";
import { baseURL } from "../../api/api";

export default function Navbar({ toggleSidebar, toggleTheme, theme }) {

  const navigate = useNavigate();
    const userName = localStorage.getItem("userName");


 const handleLogout = async () => {
  try {
    const response = await superAdminApis.superAdminLgoutAPI();

    if (response?.apiStatus?.code === "200") {
      toast(response?.apiStatus?.message)
      localStorage.removeItem("isLoggedIn");
      localStorage.clear();
      sessionStorage.clear();

      navigate('/');
    } else {
      console.log("Logout failed:", response?.apiStatus?.message);
    }
  } catch (err) {
    console.log("Logout error:", err);
  }
};


  useEffect(() => {
    fetchUser();
  }, []);


    const [userData, setUserData] = useState(null); 

  const fetchUser = async () => {
    try {
      const res = await superAdminApis.profileGetAPI();
      if (res?.apiStatus?.code === 200 || res?.apiStatus?.code === "200") {
        setUserData(res.result); 
      } else {
        toast.error("Failed to fetch user");
      }
    } catch (err) {
      console.error(err);
      toast.error("Failed to fetch user");
    }
  };

  return (
    <div className="navbar">

      {/* LEFT */}
      <div className="nav-left">
        <div className="menu-btn" onClick={toggleSidebar}>
          <i style={{fontSize:'28px',cursor:'pointer',color:'white'}} className="fas fa-bars"></i>
        </div>
      </div>

      
     

      {/* RIGHT */}
      <div className="nav-right">

        {/* Theme Toggle */}
        <button onClick={toggleTheme} className="theme-btn">
          {theme === "light" ? (
            <i className="fas fa-moon"></i>
          ) : (
            <i className="fas fa-sun"></i>
          )}
        </button>


 <div className="profile-section">
    <img
       src={
                  userData?.profileImage
                    ? `${baseURL}${userData.profileImage.path}${userData.profileImage.altered_file_name}`
                    : "https://cdn-icons-png.flaticon.com/512/3135/3135715.png"
                }
      alt="profile"
      className="profile-img"
    />

    <span className="profile-text">Hi {userName}</span>

    {/* <button className="logout-btn">Logout</button> */}


 <button class="Btn">
            <div class="sign">
              <svg viewBox="0 0 512 512">
                <path d="M377.9 105.9L500.7 228.7c7.2 7.2 11.3 17.1 11.3 27.3s-4.1 20.1-11.3 27.3L377.9 406.1c-6.4 6.4-15 9.9-24 9.9c-18.7 0-33.9-15.2-33.9-33.9l0-62.1-128 0c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32l128 0 0-62.1c0-18.7 15.2-33.9 33.9-33.9c9 0 17.6 3.6 24 9.9zM160 96L96 96c-17.7 0-32 14.3-32 32l0 256c0 17.7 14.3 32 32 32l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-64 0c-53 0-96-43-96-96L0 128C0 75 43 32 96 32l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32z"></path>
              </svg>
            </div>
            <div onClick={handleLogout} class="texts">
              Logout
            </div>
          </button>

  </div>
        

      </div>

    </div>
  );
}